import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19 3.91h-4v-.978C15 1.271 13.7 0 12 0H8C6.3 0 5 1.27 5 2.932v.978H1c-.6 0-1 .391-1 .978 0 .586.4.977 1 .977h1v12.709c0 1.662 1.3 2.933 3 2.933h10c1.7 0 3-1.271 3-2.933V5.865h1c.6 0 1-.39 1-.977s-.4-.978-1-.978M7 2.932c0-.586.4-.977 1-.977h4c.6 0 1 .39 1 .977v.978H7zm9 15.642c0 .586-.4.977-1 .977H5c-.6 0-1-.39-1-.977V5.865h12zM8 8.798c-.6 0-1 .391-1 .978v5.865c0 .587.4.978 1 .978s1-.391 1-.978V9.775c0-.586-.4-.977-1-.977m4 0c-.6 0-1 .391-1 .978v5.865c0 .587.4.978 1 .978s1-.391 1-.978V9.775c0-.586-.4-.977-1-.977"
    }, null, -1)
  ]))]))
}
export default { render: render }